export default {
  ...window.moreEnJSON,
  下载服贸会APP: 'Download CIFTIS APP',
  '加载中...': 'loading...',
  暂无数据: 'No data available',
  '已经到底了~': 'The End~',
  最新活动: 'Latest activities',
  搜索内容不能为空: 'Search content cannot be empty',
  搜索内容不能全是特殊字符: 'Search content cannot be only special characters',
  搜索: 'Search',
  搜索结果页: 'Result',
  登录注册: 'Log  in',
  // 媒体登录: 'Log  in',
  已登录: 'Log',
  年: '-',
  月: '',
  服务信息: 'Service Info',
  服贸会: 'CIFTIS',
  高峰论坛: 'Summit Forums',
  专题论坛: 'Thematic Forums',
  '网络异常，请稍后重试': 'Network exception, please try again',
  '您访问的页面找不到了~': 'Page not found~',
  '服务器未响应~': 'No response from the server~',
  '无法连接网络，请检查网络或重试~':
    'Unable to connect the network, please diagnose network or retry~',
  '请求失败，请稍后重试~': 'Request failed, please try again later~',
  无权限温馨提示: 'Access denied',
  温馨提示: 'Tips',
  '您为个人用户无访问权限，请先至服贸会官网-账户中心完善资质。':
    'You do not have the access right as an individual user. Please correct your qualifications in CIFTIS - Account Center.',
  点击重试: 'Click to Retry',
  '全球服务 互惠共享':
    'Global services with countless synergistic opportunities',
  '移动随行，呈现永不落幕的服贸会':
    'A never-ending service trade fair you can take with you anywhere',
  '北京市国际服务贸易事务中心版权所有 京ICP备12034776':
    'Beijing International Service Trade Center Copyright 京ICP备12034776',
  京公安备11010502026749: 'Beijing Public Security 11010502026749',
  京公网安备11010502041813: 'Beijing Public Security 11010502041813',
  登录: 'Login',
  共: 'Total ',
  条结果: 'results',
  '敬请期待…': 'Stay tuned...',
  下载: 'Download',
  确认: 'Confirm',
  取消: 'Cancel',
  '+86 10 64529701': '+86 10 64529702',
  新闻中心: 'Media center',
  新闻中心资讯: 'Media center Report',
  新闻中心资讯详情: 'Media center Report Details',
  资讯列表: ' Report',
  资讯详情: ' Report Details',
  '新闻中心 | 新闻资讯': 'Media center | news report',
  前往注册: 'go to register',
  查看全部: 'View All',
  '最新动态、采访资料、服务资讯，供您随时查阅下载':
    'The latest news, interviews and service information are available for your reference and download at any time',
  新闻动态: 'News',
  最新通知: 'Latest Notice',
  新闻中心通知: 'Media center Latest Notice',
  新闻中心资料: 'Media center Data',
  新闻中心通知详情: 'Media center Latest Notice Details',
  新闻中心搜索详情: 'Media center Search for details',
  活动日历: 'Events Calendar',
  预约申请: 'Reservation application',
  预约详情: 'Reservation details',
  新闻中心预约详情: 'Media Center Reservation Details',
  新闻中心资料详情: 'Media Center Data Details',
  媒体服务: 'Service Info',
  媒体详情: 'Service Details',
  资料详情: 'Data details',
  新闻中心媒体详情: 'Media center Service Details',
  资料中心: 'Data center',
  来源: 'Source',
  新闻详情: 'News',
  图片来源: 'Picture Source',
  发表时间: 'Release Time',
  通知详情: 'Interviews',
  浏览量: 'page view',
  新闻中心首页: 'Media Center Home',
  线上: 'Online',
  线下: 'Offline',
  商务服务: 'Business Services',
  线下线上相结合: 'Offline & Online',
  开门: 'Open',
  闭门: 'Private',
  // 最新通知: 'Latest Notice',
  首页: 'HOME',
  新闻中心咨询电话: 'Media Center TEL',
  新闻中心咨询邮箱: 'Media Center Email',
  页: 'page',
  第: 'Day',
  天: '',
  搜索详情: 'Search for details',
  回到顶部: 'Back to top',
  媒体登录: 'Media login',
  焦点新闻: 'Hot news',
  账户中心: 'Account Center',
  运营平台: 'Operation Platform',
  线上会议: 'Online Conference',
  退出登录: 'Log Out',
  '暂无活动/会议安排': 'No event/Conference agenda',
  '仅对媒体记者开放，请先至服贸会官网-新闻中心注册申请': 'a',
  '京ICP备 12034776号-1': 'J ICP B No.12034776-1',
  北京市国际服务贸易事务中心版权所有:
    'Copyright © Beijing International Trade in Services Center. All Rights Reserved',
  '媒体记者注册后，需等待终审通过才能访问新闻中心媒体板块':
    'After registration, a media reporter can access the media sections under News after passing in the final approval',
  '如果您还未注册，或尚未收到终审通过通知，请访问':
    'If you have not registered, or have not received the final approval notice, please visit the',
  '进行注册或查询审核状态。': 'to register or check the approval status.',
  媒体注册系统: 'Media Registration System',
  请输入您用于注册媒体记者的身份证件号:
    'Please enter the ID number for reporter registration',
  验证并登录: 'Verify and log in',
  '媒体注册审核结果更新可能存在延时。':
    'The update of media registration approval result may be delayed. ',
  请访问: 'please visit the',
  '媒体记者注册后，需等待终审通过才能访问新闻中心媒体板块。请在PC端登录媒体注册系统，进行注册或查询审核状态。':
    'After registration, a media reporter can access the media sections under News after passing in the final approval. Please log in to the media registration system on the PC to register or check the approval status. ',
  立即验证: 'Verify now',
  请填写: 'Please fill',
  '验证成功，正在跳转新闻中心！': 'Verified successfully, jumping to News !',
  '身份证号输入有误！': 'The ID number is entered incorrectly!',
  '验证不通过！': 'Verification failed',
  '您的信息审核结果更新可能存在延时，请于收到终审通过通知的1个工作日后再试！':
    'The update of your information approval result may be delayed, please try again after 1 working day after receiving the notice of ‘final approval passed ',
  '请登录记者注册系统，查看审核状态':
    'Please log in to Reporter Registration System to check the approval status',
  请登录: 'Please log in to ',
  记者注册系统: 'Reporter Registration System',
  '，查看审核状态': ' to check the approval status',
  以普通用户身份继续访问: 'Normal user access',
  '请访问媒体注册系统进行注册或查询审核状态。':
    'please visit Media Registration System to register or check the approval status. ',
  返回新闻中心: 'Back to News ',
  请输入身份证件号: 'Please enter the ID number',
  '身份证件号输入有误！': 'The ID number is entered incorrectly!',
  身份验证: 'Identity verification',
  '如果您还未注册，或尚未收到终审通过通知，请访问媒体注册系统进行注册或查询审核状态。':
    'If you have not registered, or have not received the final approval notice, please visit the Media Registration System to register or check the approval status.',
  验证不通过: 'Verification failed',
  立即登录: 'Login immediately',
  注册记者验证: 'Verification of Registered Reporter',
  '目前操作人数过多，系统繁忙，请稍后刷新再试一次。':
    'There are too many operators at present and the system is busy. Please refresh the page and try again later.',
  确定: 'OK',
  媒体记者注册已关闭: 'Media reporter registration closed',
  参观购票: 'Ticket',
  融媒应用: 'Media Application'
}
